export const TFWeightChoice = {
  CUSTOM_LABEL: 'Customise the weights',
  CUSTOM_VALUE: 'custom',
  EQUAL_LABEL: 'Equally Weight',
  EQUAL_VALUE: 'equal',
  EQUAL_WEIGHT: 'Equal Weights',
  CUSTOM_WEIGHT: 'Custom Weights',
}